var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.084 9.196c.68-.83 1.1-1.843 1.206-2.91C15.62 2.878 12.946 0 9.617 0H.714C.32 0 0 .32 0 .714v2.143c0 .395.32.714.714.714h1.423V16.43H.714c-.394 0-.714.32-.714.714v2.143c0 .394.32.714.714.714h9.345c3.16 0 5.988-2.31 6.295-5.464.211-2.163-.732-4.11-2.27-5.34zM5.7 3.571h3.918c1.183 0 2.143.96 2.143 2.143 0 1.184-.96 2.143-2.143 2.143H5.699V3.571zM9.617 16.43H5.699v-5h3.918c1.38 0 2.5 1.119 2.5 2.5 0 1.38-1.12 2.5-2.5 2.5z",
    transform: "translate(4 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.e37415f246d31ce88891fb768d31754b.svg";
export { ForwardRef as ReactComponent };